import * as htmlToImage from "html-to-image";
import ReactDOM from "react-dom";
import waait from "waait";

const DEFAULT_FILE_NAME = "Ma fleur";

/**
 * @param  {string} uri
 * @param  {string} filename
 */
const saveAs = (uri, filename) => {
  const link = document.createElement("a");

  if (typeof link.download === "string") {
    link.href = uri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    window.open(uri);
  }
};

/**
 * @param  {React.RefObject} node
 * @param  {string} fileName
 * @param  {string} type
 * @param  {object} html2CanvasOptions={}
 */

const exportComponent = async (node) => {
  if (!node.current) {
    throw new Error("'node' must be a RefObject");
  }
  // To be sure that the animation is finished -_-
  await waait(1500);
  // eslint-disable-next-line
  const element = ReactDOM.findDOMNode(node.current);

  return htmlToImage
    .toPng(element, { backgroundColor: "#FFFFFF" })
    .then(function (dataUrl) {
      saveAs(dataUrl, DEFAULT_FILE_NAME);
    });
};

const convertComponentToBase64 = async (node) => {
  if (!node.current) {
    throw new Error("'node' must be a RefObject");
  }
  // To be sure that the animation is finished -_-
  await waait(2000);
  // eslint-disable-next-line
  const element = ReactDOM.findDOMNode(node.current);
  return htmlToImage
    .toPng(element, { backgroundColor: "#FFFFFF" })
    .then(async (dataUrl) => {
      return dataUrl;
    });
};
export { exportComponent, convertComponentToBase64 };
